import React, { useState, useEffect } from 'react'
import "./CustomDatatableProduct.css";
import { FaPencilAlt } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import { getProductCategory, getProductCategory2 } from '../../services/http';
import { BiEdit } from "react-icons/bi"
import DeleteConfirmation from '../DeleteConfirmation/DeleteConfirmation';
import Pagination from '../Pagination/Pagination';
import { deleteProduct, getProducts } from '../../services/http';
import { toast } from 'react-toastify';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { reload } from '../../utils/utils';
import AddOrEditProduct from '../AddOrEditProduct/AddOrEditProduct';


const CustomDatatableProduct = (props) => {

    const { columns, data,
        changePage,
        pageCount,
        pageNumber,
        perPage,
        handleShowDeleteModal,
        handleCloseDeleteModal } = props;


    const states = useSelector((state) => state, shallowEqual);

    const [processOngoing, setProcessOngoing] = useState(false)

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleYesClicked = async (produit) => {
        setProcessOngoing(true)
        const reqdata = await deleteProduct(produit, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status !== 404 && reqdata.response.status !== 500) {

                let errorMsg = reqdata.response?.data.error["libelle"][0];

                toast.error(errorMsg, {
                    position: toast.POSITION.TOP_RIGHT,
                    className: 'rotateY animated'
                });
            } else {
                //    Should redirect to an Error Page
                console.log(reqdata.response?.data.error)
            }
        } else {
            let response = await getProducts(states.userToken.access_token, 1, "");

            let response_copy = response.data.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))

            dispatch({
                type: "SET",
                key: "productList",
                payload: response_copy,
            });
            setProcessOngoing(false)
            toast.success("Produit supprimé avec succès !", {
                position: toast.POSITION.TOP_RIGHT,
                className: 'rotateY animated'
            });
            // reload()
        }



    }


    return (
        <>

            <div className="table-responsive ">
                <table className="table table-striped dataTable w-100">
                    <thead className="">
                        <tr role={"row"}>
                            {columns && columns.map((item, index) =>
                                <th key={index+"wcdpc"} className="text-left pl-5" aria-sort="ascending" >
                                    {item.label}</th>
                            )}
                            <th className="text-center w-30">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length != 0 ? data?.map((item, index) =>
                            <tr key={index+"wcdpd"}>

                                <td className="text-left pl-5">{pageNumber > 1 ? (perPage * (pageNumber - 1) + (index + 1)) : (index + 1)}</td>
                                <td className="text-left pl-5">
                                    {item.libelle}
                                </td>
                                <td className="text-left pl-5">
                                    {item.category_product.libelle}
                                </td>
                                <td className="">
                                    <BiEdit
                                        // onClick={() => handleShowEditModal(item.id)} 
                                        onClick={() => navigate(`/product/${item.id}`)}
                                        title="Modifier" style={{ fill: "#2196F3", height: 25, width: 30, padding: 2, cursor: "pointer" }}
                                        className="custom-edit-button mr-1" />
                                    <MdDeleteForever onClick={() => handleShowDeleteModal(item.id)} title="Supprimer" style={{ fill: "red", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-delete-button ml-1" />
                                </td>
                                <DeleteConfirmation processOngoing={processOngoing} handleYesClicked={handleYesClicked} title={` le produit ${item.libelle} ?`} id={item.id} show={item.showDelete} handleNoClicked={handleCloseDeleteModal} />
                                {/* <DeleteConfirmationInstitutionCategory onExit={onExit} title={"Etes-vous sûr de vouloir supprimer la catégorie " + `${item.libelle}` + " ?"} idCategory={item.id} show={item.showDelete} handleNoClicked={handleCloseDeleteModal} /> */}
                            </tr>
                        ) : <h1 className="ok"></h1>}
                    </tbody>
                </table>
                <Pagination pageCount={pageCount} changePage={changePage} />
            </div>


        </>
    )
}

export default CustomDatatableProduct
